import script from "./ParkosMark.vue?vue&type=script&setup=true&lang=js"
export * from "./ParkosMark.vue?vue&type=script&setup=true&lang=js"

import "./ParkosMark.vue?vue&type=style&index=0&id=58bb1906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58bb1906"]])

export default __exports__